import { Component, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, OnInit } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NxExpertModule } from '@aposin/ng-aquila/config';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import { NxDialogService } from '@aposin/ng-aquila/modal';
import { NxFooterMenuModule, NxGoogleMapsService } from '@multiasistencia/multiasistencia';
import { filter } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { AuthService } from './core/services/auth.service';
import { AdobeAnalyticsService } from './core/services/adobe-analytics.service';

registerLocaleData(localeEs);
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeDe);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NxExpertModule, TranslateModule, NxFooterMenuModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    NxDialogService,
    TranslateService,
    {
      provide: LOCALE_ID,
      deps: [AuthService],
      useFactory: (auth: AuthService) => auth.getLocalStorageLanguage() || 'de-DE'
    }
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MAValue';

  constructor(
    public translate: TranslateService,
    private _GoogleMapService: NxGoogleMapsService,
    private _router: Router,
    private _titleService: Title,
    private _authService: AuthService
  ) {
    // 1️⃣ Configurar idiomas
    this.translate.addLangs(['en', 'fr', 'es', 'it', 'de']);

    // 2️⃣ Definir idioma por defecto
    const savedLang = this._authService.getLocalStorageLanguage() || 'fr';
    this.translate.setDefaultLang(savedLang);

    // 3️⃣ Activar idioma actual
    this.translate.use(savedLang);

    // Actualizar atributo <html lang="...">
    document.querySelector('html')?.setAttribute('lang', savedLang);
  }

  ngOnInit(): void {
    // Traducir título de ruta en cada navegación
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateRouteTitle();
    });

    // Traducir título si se cambia el idioma en caliente
    this.translate.onLangChange.subscribe((event) => {
      this.updateRouteTitle();
      document.querySelector('html')?.setAttribute('lang', event.lang);
    });
  }

  private updateRouteTitle() {
    let activeRoute = this._router.routerState.root;
    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }

    const titleKey = activeRoute.snapshot.data['title'];
    if (titleKey) {
      this.translate.get(titleKey).subscribe((translatedTitle) => {
        this._titleService.setTitle(`${translatedTitle} - ${this.title}`);
      });
    } else {
      this._titleService.setTitle(this.title);
    }
  }
}
